import React, { useState, useEffect } from 'react';
import { Button, Nav, NavItem, NavLink } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import CadastroRegraVersao from './Components/CadastroRegraVersao';

//Api
import regraVersaoSistema_api from '../../../../api/regraVersaoSistema_api';

//Helpers
import { showMessage, showQuestion } from '../../../../helpers/message';
import { CATEGORIA_REGRA, CATEGORIA_VERSAO, abrirConsultaPublica, filtrarPorCategoria } from './helpers/regrasEVersoes';

//Context
import { useAuth } from '../../../../context/auth';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

export default function RegrasEVersoes({ permissoes }) {

    //Estado de controle de exibição da tela de cadastro
    const [cadastro, setCadastro] = useState(false);

    //Estado de controle da lista de regras e versões
    const [regrasVersoes, setRegrasVersoes] = useState([]);

    //Estado de controle de visualização/edição de um item específico
    const [idRegraVersao, setIdRegraVersao] = useState(null);

    //Aba ativa: Regras do Sistema ou Versão do Sistema
    const [categoriaAtiva, setCategoriaAtiva] = useState(CATEGORIA_REGRA);

    //Pegando o estado de controle do loading na tela
    const { setLoading } = useAuth();

    //Variavel de controle de edição da tela
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    const visualizar = (rowData) => setIdRegraVersao(rowData.id);

    const editar = (rowData) => setIdRegraVersao(rowData.id);

    const excluir = (rowData) => {
        showQuestion(
            "Excluir",
            `Deseja realmente excluir "${rowData.titulo}"?`,
            "warning",
            (confirmado) => {
                if (!confirmado)
                    return;

                setLoading(true);
                regraVersaoSistema_api.delete(rowData.id)
                    .then(() => showMessage("Sucesso", "Registro excluído com sucesso", "success", loadRegrasVersoes))
                    .catch(e => showMessage("Erro", e.message, "error", null))
                    .finally(() => setLoading(false));
            }
        );
    };

    //Ações que a tabela terá
    const actions = [
        actionsTable.visualizar(visualizar),
        ...editavel
            ? [actionsTable.editar(editar), actionsTable.remover(excluir)]
            : []
    ];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Data da Publicação", objectValue: "dataPublicacaoFormatada", align: "left" },
        { value: "Título", objectValue: "titulo", align: "left" },
        { value: "Status", objectValue: "status", align: "left" }
    ];

    //Função que carrega a lista de regras e versões
    const loadRegrasVersoes = () => {
        setLoading(true);
        regraVersaoSistema_api.getList().then(response => {
            setRegrasVersoes(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadRegrasVersoes();
    }, []);

    const handleVoltar = () => {
        setCadastro(false);
        setIdRegraVersao(null);
        loadRegrasVersoes();
    }

    if (cadastro || idRegraVersao)
        return (
            <CadastroRegraVersao
                btnVoltar={handleVoltar}
                id={idRegraVersao}
                editavel={editavel}
                categoriaPadrao={categoriaAtiva}
            />
        );

    const abaClassName = (categoria) =>
        `${categoriaAtiva === categoria ? "active fw-bold text-success" : "text-secondary"}`;

    const abaStyle = (categoria) =>
        ({ backgroundColor: categoriaAtiva === categoria ? "#fff" : "#ccc" });

    return (
        <>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4 className='text-secondary m-0'>Regras e Versões do Sistema</h4>
                <div className='d-flex align-items-center gap-2'>
                    <Button color='primary' onClick={abrirConsultaPublica} title='Abre a consulta pública em uma nova aba'>
                        <FontAwesomeIcon icon={faUpRightFromSquare} /> Consulta pública
                    </Button>
                    {editavel &&
                        <Button color='success' onClick={() => { setCadastro(true) }}>+ Cadastrar</Button>
                    }
                </div>
            </div>
            <Nav tabs className='mb-3'>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={abaStyle(CATEGORIA_REGRA)}
                        className={abaClassName(CATEGORIA_REGRA)}
                        onClick={() => setCategoriaAtiva(CATEGORIA_REGRA)}
                    >
                        Regras do Sistema
                    </NavLink>
                </NavItem>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={abaStyle(CATEGORIA_VERSAO)}
                        className={abaClassName(CATEGORIA_VERSAO)}
                        onClick={() => setCategoriaAtiva(CATEGORIA_VERSAO)}
                    >
                        Versões do Sistema
                    </NavLink>
                </NavItem>
            </Nav>
            <TabelaListagem
                actions={actions}
                title={categoriaAtiva === CATEGORIA_REGRA ? "Regras do Sistema" : "Versões do Sistema"}
                options={{ print: false, search: true, pagination: true }}
                headers={headers}
                items={filtrarPorCategoria(regrasVersoes, categoriaAtiva)}
            />
        </>
    )
}
